<div class="header">
    @if (hasBackButton()) {
        <a (click)="location.back()" class="back-button">
            <mat-icon svgIcon="chevronLeft" />
            {{ 'back' | translate }}
        </a>
    }
    <div class="title-container" id="kyc-kyb-header">
        <div role="heading" [attr.aria-level]="headingLevel()">
            {{ 'payroll.kyc-kyb.title' | translate: { scope: ('payroll.kyc-kyb.scopes.' + scope() | translate) } }}
        </div>
        <app-kyc-kyb-badge [status]="status()" />
    </div>
</div>

<ng-template #titleContent>
    {{ 'payroll.kyc-kyb.title' | translate: { scope: ('payroll.kyc-kyb.scopes.' + scope() | translate) } }}
</ng-template>
